import React from 'react';
import {
  Columns,
  StyledFirstColumn,
  StyledPaperContainer,
  StyledSecondColumn
} from '../../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { ClinicFormProps, ClinicIdProps } from '../../../CreateClinic/types';
import { ClinicCondition } from '../../../types';
import ConditionViewersList from './ConditionViewersList';
import AddConditionButton from './AddConditionButton';
import styled from 'styled-components';
import ClinicConditionEditorContainer from '../ClinicConditionEditor/ClinicConditionEditorContainer';

const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`;

export type ClinicConditionsListProps = ClinicFormProps & ClinicIdProps;

function ClinicConditionsList({ form, clinicId }: ClinicConditionsListProps) {
  return (
    <StyledPaperContainer>
      <Columns>
        <StyledSecondColumn>
          <ConditionViewersList form={form} clinic={{ _id: clinicId }} />
          <ActionButtons form={form} clinicId={clinicId} />
        </StyledSecondColumn>
        <StyledFirstColumn>
          <ClinicConditionEditorContainer clinicId={clinicId} form={form} />
        </StyledFirstColumn>
      </Columns>
    </StyledPaperContainer>
  );
}

interface ActionButtonsProps extends ClinicFormProps {
  clinicId: string;
}

function ActionButtons({ form, clinicId }: ActionButtonsProps) {
  const hasNewCondition = useHasNewCondition(form);

  return (
    <ActionButtonsContainer>
      <AddConditionButton form={form} isVisible={!hasNewCondition} clinicId={clinicId} />
    </ActionButtonsContainer>
  );
}

const useHasNewCondition = (form: ClinicFormProps['form']) => {
  const conditions = form.watch('clinic_conditions');

  const isNew = (condition: ClinicCondition) => !condition.condition_id;

  return conditions.some(isNew);
};

export default ClinicConditionsList;
